module.exports = __webpack_public_path__ + "static/media/logo-blanco.e9f49bab.svg";